import { SimpleAttributeCoreBase } from "./simple-attribute.core.base"


export class SimpleAttributeCore extends SimpleAttributeCoreBase {

}